<div class="stats-ai-toggle-container">
  <button
    class="toggle-btn"
    [class.active]="mode === 'actas'"
    (click)="toggleMode('actas')">
    <i class="fas fa-file-pdf"></i>
    <span>Actas Oficiales</span>
  </button>

  <button
    class="toggle-btn"
    [class.active]="mode === 'ia'"
    (click)="toggleMode('ia')">
    <i class="fas fa-robot"></i>
    <span>IA Estadísticas</span>
  </button>
</div>
